import { render, staticRenderFns } from "./salesaexec.vue?vue&type=template&id=18c64f97"
import script from "./salesaexec.vue?vue&type=script&lang=js"
export * from "./salesaexec.vue?vue&type=script&lang=js"
import style0 from "./salesaexec.vue?vue&type=style&index=0&id=18c64f97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports